import { createStyle } from "~/common/utils/create-style";

const userInfoStyle = createStyle({
  slots: {
    triggerButton: [
      "w-full flex flex-row gap-8",
      "!text-body-2-emphasis text-text-primary p-8 rounded-l",
      "data-[state=open]:bg-overlay-30 hover:bg-overlay-30 hover:cursor-pointer",
    ],
    username: "grow text-start font-medium",
    warningContainer: "flex justify-center items-center size-20",
    warningIcon: "rounded-full bg-system-on-dark-red-02 size-[8px]",
    popoverContainer: [
      "w-[24rem] rounded-xl bg-white",
      "text-text-primary-on-light p-[6px] z-999",
    ],
    popoverItem: [
      "flex flex-col gap-8 p-8 rounded-l text-body-2",
      "hover:outline-none hover:bg-primary-on-light-02 hover:text-white hover:cursor-pointer",
      "data-[disabled]:text-text-disabled-on-light data-[disabled]:cursor-not-allowed",
      "data-[active=true]:bg-primary-on-light-02 data-[active=true]:text-white",
    ],
    divider: "border-t border-border-solid-on-light-20 my-2 mx-2",
    userInfoContainer: "flex flex-row gap-8",
    userInfoDetails: "flex grow flex-col min-w-0",
    userName: "font-medium",
    userEmail:
      "text-body-3 text-text-tertiary-on-light overflow-hidden text-ellipsis whitespace-nowrap",
    popoverItemButton: [
      "cursor-pointer flex flex-row gap-8 rounded-l text-body-2 p-8 w-full",
      "hover:outline-none hover:bg-primary-on-light-02 hover:text-white hover:cursor-pointer",
      "data-[disabled]:text-text-disabled-on-light data-[disabled]:cursor-not-allowed",
      "data-[active=true]:bg-primary-on-light-02 data-[active=true]:text-white",
    ],
    popoverItemButtonText: "grow font-medium text-start",
    themePopoverContainer:
      "p-4 bg-white rounded-[12px] border w-[116px] flex flex-col border-border-on-light-opacity-02 shadow-sm",
    themePopoverItem: [
      "rounded-l text-body-2 flex flex-row gap-[6px] p-[8px] text-black w-full",
      "hover:bg-overlay-on-light-30 hover:cursor-pointer",
    ],
    checkIconWrapper:
      "inline-flex items-center justify-center w-[20px] h-[20px]",
  },
  variants: {
    theme: {
      light: {
        popoverContainer:
          "border-border-opacity-20 shadow-[0_-1px_3px_rgba(0,0,0,0.08),0_4px_6px_rgba(0,0,0,0.08)]",
      },
    },
  },
})();

export { userInfoStyle };
